var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26585_82520",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26585_82520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3768 14.0182L10.0018 12.4349L12.6268 14.0391L11.9393 11.0391L14.2518 9.03906L11.2101 8.76823L10.0018 5.9349L8.79347 8.7474L5.7518 9.01823L8.0643 11.0391L7.3768 14.0182ZM10.0018 14.3932L6.54347 16.4766C6.39069 16.5738 6.23097 16.6154 6.0643 16.6016C5.89764 16.5877 5.7518 16.5321 5.6268 16.4349C5.5018 16.3377 5.40458 16.2161 5.33514 16.0703C5.26569 15.9245 5.2518 15.7613 5.29347 15.5807L6.21014 11.6432L3.14764 8.9974C3.00875 8.8724 2.92194 8.73003 2.88722 8.57031C2.8525 8.41059 2.86291 8.25434 2.91847 8.10156C2.97403 7.94878 3.05736 7.82378 3.16847 7.72656C3.27958 7.62934 3.43236 7.56684 3.6268 7.53906L7.66847 7.1849L9.23097 3.47656C9.30041 3.3099 9.40805 3.1849 9.55389 3.10156C9.69972 3.01823 9.84903 2.97656 10.0018 2.97656C10.1546 2.97656 10.3039 3.01823 10.4497 3.10156C10.5956 3.1849 10.7032 3.3099 10.7726 3.47656L12.3351 7.1849L16.3768 7.53906C16.5712 7.56684 16.724 7.62934 16.8351 7.72656C16.9462 7.82378 17.0296 7.94878 17.0851 8.10156C17.1407 8.25434 17.1511 8.41059 17.1164 8.57031C17.0817 8.73003 16.9949 8.8724 16.856 8.9974L13.7935 11.6432L14.7101 15.5807C14.7518 15.7613 14.7379 15.9245 14.6685 16.0703C14.599 16.2161 14.5018 16.3377 14.3768 16.4349C14.2518 16.5321 14.106 16.5877 13.9393 16.6016C13.7726 16.6154 13.6129 16.5738 13.4601 16.4766L10.0018 14.3932Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOff);
export default __webpack_public_path__ + "static/media/star-off.73ac5b0c599b6eff8dadf344cc5bca2c.svg";
export { ForwardRef as ReactComponent };